import SegmentView from '@/ux/views/segments/SegmentView.vue';

export default
[
    {
        path: '/segment/:id',
        name: 'segmentView',
        component: SegmentView,
        props: true,
    },
];
